import { useController } from 'react-hook-form';
import { Check } from 'react-feather';
import classNames from 'classnames';
import Error from '../Error';
var Checkbox = function (_a) {
    var children = _a.children, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? '' : _b, name = _a.name, _c = _a.value, value = _c === void 0 ? null : _c, id = _a.id, control = _a.control, defaultValue = _a.defaultValue;
    var _d = useController({ name: name, control: control, defaultValue: defaultValue }), field = _d.field, fieldState = _d.fieldState;
    return (<div className="flex w-full flex-col">
      <label className="flex items-start gap-4">
        <span className={classNames('flex h-5 w-5 flex-shrink-0 cursor-pointer items-center justify-center rounded border border-gray-400 transition-colors', field.value && 'border-transparent bg-alert-success')}>
          {field.value && <Check size={16} className="text-white"/>}
        </span>
        <input type="checkbox" className="hidden" aria-label={ariaLabel} name={name} id={id ? id : name} defaultChecked={!!defaultValue} onClick={function () { return field.onChange(!field.value); }} value={value}/>
        <span>{children}</span>
      </label>
      {fieldState.error && <Error message={fieldState.error.message}/>}
    </div>);
};
export default Checkbox;
